import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Properties from './pages/properties';
import Error from './pages/error';
import Details from './pages/details';
function Paths() {
    return (

    <BrowserRouter>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/details" element={<Details />} />

        <Route path="*" element={<Error />} />

    </Routes>
    </BrowserRouter>
    );
}
 
export default Paths;